<template>
  <!-- prettier-ignore -->
  <div class="advice-tab">
    <div class="advice-tab-content">
      <the-typography
        type="heading05"
        v-text="$t(`screen.priceWidget.advice.${componentKey}.content.title`)"
      />
      <p v-text="$t(`screen.priceWidget.advice.${componentKey}.content.text`)" />
      <Form.Button
        :href="$t(`screen.priceWidget.advice.${componentKey}.content.link`)"
        primary
        data-track-as="priceWidget"
        :data-track-text="$t(`screen.priceWidget.advice.${componentKey}.content.button`)"
        v-text="$t(`screen.priceWidget.advice.${componentKey}.content.title`)"
      />
    </div>
    <div class="advice-tab-image">
      <img
        alt="advice-tab_image"
        class="advice-tab-image__image"
        :src="componentImage"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import * as Form from '@/components/Form'

const props = defineProps({
  tabContent: {
    type: Object,
    default: () => {},
  },
})

// Computed
const componentKey = computed(() => {
  return props.tabContent.componentKey
})

const componentImage = computed(() => {
  return props.tabContent.image
})
</script>

<style name="mobile" scoped>
.advice-tab {
  color: var(--c-primary-neutral-1);
  font-size: 15px;
  line-height: 20px;
  padding: 16px;
  margin-bottom: 16px;

  background-color: var(--c-primary-neutral-3);

  p {
    margin: 20px 0;
  }

  .button {
    font-weight: bold;
  }

  &-image {
    display: none;
  }
}
</style>

<style name="desktop" scoped>
@media (--md) {
  .advice-tab {
    display: grid;
    grid-template-areas: 'content image';
    grid-template-columns: 1fr 200px;
    grid-gap: 8px;

    &-content {
      grid-area: content;
    }

    &-image {
      grid-area: image;
      padding: 44px 0 0 0;
      display: initial;

      &__image {
        height: 164px;
        width: 164px;
        float: right;
        object-fit: cover;
      }
    }
  }
}
</style>
